module.exports = __webpack_public_path__ + "img/Small_johan.4dd5a6ed.png";